function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_7_491)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 26.9824,
  x2: 1444,
  y2: 26.9824,
  stroke: "#B0DAC7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.6548 49.6358C75.0147 38.809 66.5006 30.2949 55.6738 26.6548C66.5006 23.0147 75.0147 14.5007 78.6548 3.6738C82.2949 14.5007 90.8089 23.0147 101.636 26.6548C90.8089 30.2949 82.2948 38.809 78.6548 49.6358Z",
  fill: "black",
  stroke: "#B0DAC7",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M924.655 49.6358C921.015 38.809 912.501 30.2949 901.674 26.6548C912.501 23.0147 921.015 14.5007 924.655 3.6738C928.295 14.5007 936.809 23.0147 947.636 26.6548C936.809 30.2949 928.295 38.809 924.655 49.6358Z",
  fill: "black",
  stroke: "#B0DAC7",
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_7_491",
  x: 0,
  y: 0,
  width: 1448,
  height: 61.3096,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7_491"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7_491",
  result: "shape"
})));

function SvgProductionFooterStarLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1448,
    height: 62,
    viewBox: "0 0 1448 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionFooterStarLine);
export default __webpack_public_path__ + "static/media/production_footer_star_line.180f95f5.svg";
export { ForwardRef as ReactComponent };